import { useQuery } from '@tanstack/react-query';
import { getFieldBindings } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const buildFieldBindingsQueryKey = (args: {
	dealId: string;
	programmeId: string;
	templateId: string;
}): string => `field-bindings-${args.dealId}-${args.programmeId}-${args.templateId}`;

export const useFieldBindingsQuery = (templateId: string | null, enabled = true) => {
	const { dealId, mipId } = useRequiredParams('dealId', 'mipId');

	const key = buildFieldBindingsQueryKey({
		dealId,
		programmeId: mipId,
		templateId: templateId ?? '',
	});

	return useQuery({
		queryKey: [key],
		queryFn: () => getFieldBindings(dealId, mipId, templateId ?? ''),
		enabled: !!templateId && enabled,
	});
};
